import { SparePart } from '../models/spare-part.interface';
import { createAction, props } from '@ngrx/store';

export const loadParts = createAction('[Sbom/API] Load Spare parts');

export const retrievedParts = createAction('[Sbom/API] Retrieve Spare parts Success', props<{ parts: SparePart | null }>());
